import Splide from "@splidejs/splide";

export const colorSlider = () => {
  if (document.querySelector(".js-color-slider") !== null) {
    const splide = new Splide(".js-color-slider", {
      gap: "3rem",
      perMove: 1,
      perPage: 1,
      arrows: false,
      updateOnMove: true,
      classes: {
        pagination: "splide__pagination color-slider__pagination",
        page: "splide__pagination__page color-slider__pagination-page",
      },
    });

    if (window.matchMedia(`(max-width: 768px)`).matches) {
      splide.mount();
    } else {
      splide.destroy();
    }
  }
};
